import React, { Component } from 'react';
import { connect } from 'react-redux';

import NoData from '../../../components/NoData/NoData';
import { DatePicker, Options } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';

import AvgThroughput from './AvgThroughput';
import ThroughputHistogramChart from './ThroughputHistogramChart';

import '../ThroughputHistogram.scss';

class WallboardThroughputHistogramChart extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div className="content-wrap">
        <div className="dashboard_head">
          <div className='title-info'>
            <p>Throughput Histogram</p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          <div className="button_tools">
            <Options chart="th" showNavigator showAvgChart options={{ avgChartTooltip: 'Throughput Averages' }} />
            <DatePicker />
          </div>
        </div>
        <div className="dashboard_details">
          {!!this.props.data.length && this.props.avgChart && (
            <AvgThroughput
              data={this.props.data}
              excludeZeroDays={this.props.excludeZeroDays}
              dateFormat={this.props.dateFormat}
            />
          )}
        </div>
        <div className="diagram_details">
          <ThroughputHistogramChart id="ThroughputHistogram" data={this.props.data} />
          <NoData show={!this.props.data.length} loading={this.props.isLoading} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dateFormat: state.filters.dateFormat,
    avgChart: state.filters.th.avgChart,
    excludeZeroDays: state.filters.th.excludeZeroDays,
    data: state.throughputHistogram.data,
    isLoading: state.throughputHistogram.isLoading,
    dashboard: state.dashboards.selected
  };
};

export default connect(mapStateToProps)(WallboardThroughputHistogramChart);
